var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"section"}},[_c('tb',{attrs:{"t-btxt1":_vm.p2stitle1,"t-btxt2":_vm.p2stitle2,"t-button1":_vm.p2sbutton1,"t-button2":_vm.p2sbutton2,"t-burl":_vm.p2surl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }